/*-----------------outside-link---------------------------*/
  document.addEventListener("DOMContentLoaded", function() {
    document.querySelectorAll('a[href]').forEach(function(link) {
      if (link.hostname !== window.location.hostname) {
        link.setAttribute('target', '_blank');
        link.setAttribute('rel', 'noopener noreferrer');
      }
    });
  });
/*------------------end-----------------------------*/





$(document).ready(function(){
  $('.slider-nav').slick({
    slidesToShow: 3,
    slidesToScroll: 1,
    dots: false,
    autoplay: true,
    arrows: true,
    autoplaySpeed: 2000,
    focusOnSelect: true,
    responsive: [
      {
        breakpoint: 991,
        settings: {
          slidesToShow: 2
        }
      },
      {
        breakpoint: 480, 
        settings: {
          slidesToShow: 1,
        }
      }
    ],
    prevArrow: '<button type="button" class="slick-prev"><img src="https://cdn.shopify.com/s/files/1/0849/6031/3537/files/Vector_11.svg?v=1767346991" alt="Previous"></button>',
    nextArrow: '<button type="button" class="slick-next"><img src="https://cdn.shopify.com/s/files/1/0849/6031/3537/files/Vector_10.svg?v=1767346962" alt="Next"></button>'
});

// 06-03-2026 start
$('.cstm-return-req-pop-up').click(function (e) {
    e.preventDefault();
    $('.cstm-return-request-pop-up-main').css('display','block');
});
$('.cstm-product-pop-up').click(function(e){
    e.preventDefault(); 
    $('.cstm-product-page-pop-main').css('display','flex');
});
$('.close-popup').click(function (e) {
    e.preventDefault();
    $('.cstm-return-request-pop-up-main, .cstm-product-page-pop-main, .cstm-view-catalog-pop-main').css('display','none');
    $('body').removeClass('catalog-pop-up-open');
});
// 06-03-2026 end
// 09-03-2026
$(document).on('change', function(e){
    var varition_meta = $('.cstm-varition-val:checked').data('variantmeta');
    $('.cstm-varid_show').text(varition_meta);
    // console.log(varition_meta);
});
// 09-03-2026 end
$('.view-catalog').click(function (e) {
    e.preventDefault();
    $('.cstm-view-catalog-pop-main').show();
    $('body').addClass('catalog-pop-up-open');
});
});



$(document).ready(function () {

  function initMobileSlider() {
    if ($(window).width() <= 767) {

      if (!$('.slider-main').hasClass('slick-initialized')) {
        $('.slider-main').slick({
          slidesToShow: 2,
          slidesToScroll: 1,
          dots: true,
          autoplay: true,
          arrows: false,
          autoplaySpeed: 2000,
          focusOnSelect: true,
          responsive: [
            {
              breakpoint: 575,
              settings: {
                slidesToShow: 1
              }
            }
          ],
          prevArrow:
            '<button type="button" class="slick-prev"><img src="https://cdn.shopify.com/s/files/1/0849/6031/3537/files/Vector_11.svg?v=1767346991" alt="Previous"></button>',
          nextArrow:
            '<button type="button" class="slick-next"><img src="https://cdn.shopify.com/s/files/1/0849/6031/3537/files/Vector_10.svg?v=1767346962" alt="Next"></button>'
        });
      }
    } else {

      if ($('.slider-main').hasClass('slick-initialized')) {
        $('.slider-main').slick('unslick');
      }
    }
  }

  initMobileSlider();

  $(window).on('resize', function () {
    initMobileSlider();
  });

});


//*-----------close---------------*//
  $(document).ready(function(){
    $('.footer-warning img').click(function(){
        $('.footer-warning').hide();
    })
})


document.addEventListener("DOMContentLoaded", function () {
  document.querySelectorAll(".faq-question").forEach(button => {
    
    button.addEventListener("click", () => {
      const item = button.closest(".faq-item");
      const answer = item.querySelector(".faq-answer");
      const openItem = document.querySelector(".faq-item.active");

      if (openItem && openItem !== item) {
        const openAnswer = openItem.querySelector(".faq-answer");
        openAnswer.style.maxHeight = 0;
        openItem.classList.remove("active");
      }

      item.classList.toggle("active");

      if (item.classList.contains("active")) {
        answer.style.maxHeight = answer.scrollHeight + "px";
      } else {
        answer.style.maxHeight = 0;
      }
    });
  });

  const defaultOpen = document.querySelector(".faq-item.active .faq-answer");
  if (defaultOpen) {
    defaultOpen.style.maxHeight = defaultOpen.scrollHeight + "px";
  }
});


// file upload //
document.addEventListener("DOMContentLoaded", function () {
  document.querySelectorAll(".file-upload").forEach(function (wrap) {
    const input = wrap.querySelector('input[type="file"]');
    const text = wrap.querySelector(".file-text");

    input.addEventListener("change", function () {
      if (this.files.length > 0) {
        text.textContent =
          this.files.length === 1
            ? this.files[0].name
            : this.files.length + " files selected";
      } else {
        text.textContent = text.dataset.default;
      }
    });
  });
});




